<template>
  <section v-if="notices.length" class="notice-bar" aria-label="平台公告">
    <div class="container notice-inner">
      <span class="notice-icon" aria-hidden="true">◖</span><b>平台公告</b>
      <div class="marquee"><span><button v-for="notice in notices" :key="notice.id" class="notice-title" @click="openNotice(notice)">{{ notice.title }}</button></span></div>
      <button @click="openNotice(notices[0])">更多 →</button>
    </div>
  </section>
  <Teleport to="body">
    <div v-if="selectedNotice" class="modal-backdrop" @click.self="selectedNotice = null" @keydown.esc="selectedNotice = null">
      <section class="detail-modal notice-dialog" role="dialog" aria-modal="true" aria-labelledby="notice-heading">
        <button ref="closeButton" class="modal-close" aria-label="关闭公告" @click="selectedNotice = null">×</button>
        <h2 id="notice-heading">{{ selectedNotice.title }}</h2>
        <nav v-if="notices.length > 1" class="notice-list" aria-label="公告列表"><button v-for="notice in notices" :key="notice.id" :aria-current="notice.id === selectedNotice.id ? 'true' : undefined" @click="selectedNotice = notice">{{ notice.title }}</button></nav>
        <div class="notice-body" v-html="sanitizeHelpContent(selectedNotice.content)"></div>
      </section>
    </div>
  </Teleport>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import { webApi } from '../services/webApi'
import { useAppContext } from '../composables/appContext'

const { sanitizeHelpContent } = useAppContext()
const notices = ref([])
const selectedNotice = ref(null)
const closeButton = ref(null)
let requestVersion = 0

async function loadNotices() {
  const version = ++requestVersion
  try {
    const result = await webApi.notices()
    if (version === requestVersion) notices.value = Array.isArray(result) ? result : []
  } catch {
    if (version === requestVersion) notices.value = []
  }
}

async function openNotice(notice) {
  selectedNotice.value = notice
  await nextTick()
  closeButton.value?.focus()
}

onMounted(loadNotices)
onBeforeUnmount(() => { requestVersion += 1 })
</script>

<style scoped>
.notice-inner .notice-title { color:inherit; font:inherit; margin-right:24px; }
.marquee:focus-within span, .marquee:hover span { animation-play-state:paused; }
.notice-dialog { width:min(680px,100%); text-align:left; white-space:normal; }
.notice-dialog h2 { padding-right:24px; }
.notice-list { display:flex; flex-wrap:wrap; gap:8px; margin:20px 0; }
.notice-list button { padding:6px 12px; color:#52657b; background:#eef4fa; border-radius:6px; }
.notice-list button[aria-current] { color:#1674bc; background:#e1f1ff; }
.notice-body { line-height:1.8; overflow-wrap:anywhere; }
.notice-body :deep(img) { max-width:100%; height:auto; }
</style>
